import { NgModule } from '@angular/core';
import { Error404Component } from './error404/error404.component';
import { SharedModule } from '../../shared/shared.module';
import { Error500Component } from './error500/error500.component';

@NgModule({
  imports: [
    SharedModule,
    // RouterModule.forChild(routes)
  ],
  declarations: [
    Error404Component,
    Error500Component,
  ],
  exports: [
    Error404Component,
    Error500Component,
  ]
})
export class ErrorsModule { }
